import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      attrs: { "max-width": "600px", persistent: "" },
      model: {
        value: _vm.dialogProps.visibilidade,
        callback: function ($$v) {
          _vm.$set(_vm.dialogProps, "visibilidade", $$v)
        },
        expression: "dialogProps.visibilidade",
      },
    },
    [
      _c(
        VCard,
        { staticClass: "pa-5" },
        [
          _c(
            VCardTitle,
            [
              _c(
                VRow,
                { staticClass: "d-flex flex-column text-lg-center" },
                [
                  _c(
                    "h4",
                    { staticClass: "headline primary--text text-no-wrap" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.labelBtnAcao) +
                          " Experiência Profissional "
                      ),
                    ]
                  ),
                  _c("span", { staticClass: "subtitle-1" }, [
                    _vm._v("Informe os dados a respeito da experiência"),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            VCardText,
            [
              _c(
                VForm,
                {
                  ref: "form",
                  model: {
                    value: _vm.dialogProps.valid,
                    callback: function ($$v) {
                      _vm.$set(_vm.dialogProps, "valid", $$v)
                    },
                    expression: "dialogProps.valid",
                  },
                },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12", md: "12" } },
                        [
                          _c(VAutocomplete, {
                            attrs: {
                              items: _vm.listaCargos,
                              rules: [(v) => !!v || "Selecione um cargo"],
                              "search-input": _vm.cargoSearch,
                              "item-text": "nome",
                              label: "Cargo",
                              placeholder: "Digite para pesquisar...",
                              "persistent-hint": "",
                              "prepend-icon": "engineering",
                              required: "",
                              "return-object": "",
                            },
                            on: {
                              "update:searchInput": function ($event) {
                                _vm.cargoSearch = $event
                              },
                              "update:search-input": function ($event) {
                                _vm.cargoSearch = $event
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "no-data",
                                fn: function () {
                                  return [
                                    _c(
                                      VListItem,
                                      [
                                        _c(
                                          VListItemContent,
                                          [
                                            _c(VListItemTitle, [
                                              _vm._v(" O cargo "),
                                              _c(
                                                "strong",
                                                {
                                                  staticClass:
                                                    "secondary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.cargoSearch) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" não foi encontrado. "),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.experienciaProfissional.tipoCargo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.experienciaProfissional,
                                  "tipoCargo",
                                  $$v
                                )
                              },
                              expression: "experienciaProfissional.tipoCargo",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.experienciaProfissional.tipoCargo &&
                      _vm.experienciaProfissional.tipoCargo.isOutro
                        ? _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  rules: _vm.ruleNotEmpty,
                                  label: "Nome do Cargo",
                                  "prepend-icon": "library_books",
                                  required: "",
                                },
                                model: {
                                  value:
                                    _vm.experienciaProfissional.nomeCargoOutro,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.experienciaProfissional,
                                      "nomeCargoOutro",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression:
                                    "experienciaProfissional.nomeCargoOutro",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12", md: "12" } },
                        [
                          _c(VAutocomplete, {
                            attrs: {
                              items: _vm.listaSetores,
                              rules: [(v) => !!v || "Selecione um setor"],
                              "search-input": _vm.tipoSetorSearch,
                              "item-text": "nome",
                              label: "Setor",
                              placeholder: "Digite para pesquisar...",
                              "persistent-hint": "",
                              "prepend-icon": "lan",
                              required: "",
                              "return-object": "",
                            },
                            on: {
                              "update:searchInput": function ($event) {
                                _vm.tipoSetorSearch = $event
                              },
                              "update:search-input": function ($event) {
                                _vm.tipoSetorSearch = $event
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "no-data",
                                fn: function () {
                                  return [
                                    _c(
                                      VListItem,
                                      [
                                        _c(
                                          VListItemContent,
                                          [
                                            _c(VListItemTitle, [
                                              _vm._v(" O setor "),
                                              _c(
                                                "strong",
                                                {
                                                  staticClass:
                                                    "secondary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.tipoSetorSearch
                                                    ) + " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" não foi encontrado. "),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.experienciaProfissional.tipoSetor,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.experienciaProfissional,
                                  "tipoSetor",
                                  $$v
                                )
                              },
                              expression: "experienciaProfissional.tipoSetor",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.experienciaProfissional.tipoSetor &&
                      _vm.experienciaProfissional.tipoSetor.isOutro
                        ? _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  rules: _vm.ruleNotEmpty,
                                  label: "Nome do Setor",
                                  "prepend-icon": "library_books",
                                  required: "",
                                },
                                model: {
                                  value:
                                    _vm.experienciaProfissional.nomeSetorOutro,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.experienciaProfissional,
                                      "nomeSetorOutro",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression:
                                    "experienciaProfissional.nomeSetorOutro",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              rules: [(v) => !!v || "Seleciona a instituição"],
                              label: "Instituição",
                              "prepend-icon": "account_balance",
                              required: "",
                            },
                            model: {
                              value: _vm.experienciaProfissional.instituicao,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.experienciaProfissional,
                                  "instituicao",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "experienciaProfissional.instituicao",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12", md: "12" } },
                        [
                          _c(VAutocomplete, {
                            attrs: {
                              items: _vm.listaVinculos,
                              rules: [(v) => !!v || "Selecione um vínculo"],
                              "search-input": _vm.vinculoSearch,
                              "item-text": "nome",
                              label: "Vínculo",
                              placeholder: "Digite para pesquisar...",
                              "persistent-hint": "",
                              "prepend-icon": "diversity_3",
                              required: "",
                              "return-object": "",
                            },
                            on: {
                              "update:searchInput": function ($event) {
                                _vm.vinculoSearch = $event
                              },
                              "update:search-input": function ($event) {
                                _vm.vinculoSearch = $event
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "no-data",
                                fn: function () {
                                  return [
                                    _c(
                                      VListItem,
                                      [
                                        _c(
                                          VListItemContent,
                                          [
                                            _c(VListItemTitle, [
                                              _vm._v(" O vínculo "),
                                              _c(
                                                "strong",
                                                {
                                                  staticClass:
                                                    "secondary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.vinculoSearch) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" não foi encontrado. "),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.experienciaProfissional.tipoVinculo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.experienciaProfissional,
                                  "tipoVinculo",
                                  $$v
                                )
                              },
                              expression: "experienciaProfissional.tipoVinculo",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.experienciaProfissional.tipoVinculo &&
                      _vm.experienciaProfissional.tipoVinculo.isOutro
                        ? _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  rules: _vm.ruleNotEmpty,
                                  label: "Nome do Vínculo",
                                  "prepend-icon": "library_books",
                                  required: "",
                                },
                                model: {
                                  value:
                                    _vm.experienciaProfissional
                                      .nomeVinculoOutro,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.experienciaProfissional,
                                      "nomeVinculoOutro",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression:
                                    "experienciaProfissional.nomeVinculoOutro",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12", md: "12" } },
                        [
                          _c(VAutocomplete, {
                            attrs: {
                              items: _vm.listaFuncoes,
                              rules: [(v) => !!v || "Selecione uma função"],
                              "search-input": _vm.funcaoSearch,
                              "item-text": "nome",
                              label: "Função Gratificada",
                              placeholder: "Digite para pesquisar...",
                              "persistent-hint": "",
                              "prepend-icon": "badge",
                              required: "",
                              "return-object": "",
                            },
                            on: {
                              "update:searchInput": function ($event) {
                                _vm.funcaoSearch = $event
                              },
                              "update:search-input": function ($event) {
                                _vm.funcaoSearch = $event
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "no-data",
                                fn: function () {
                                  return [
                                    _c(
                                      VListItem,
                                      [
                                        _c(
                                          VListItemContent,
                                          [
                                            _c(VListItemTitle, [
                                              _vm._v(" A função "),
                                              _c(
                                                "strong",
                                                {
                                                  staticClass:
                                                    "secondary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.funcaoSearch) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" não foi encontrada. "),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.experienciaProfissional.tipoFuncao,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.experienciaProfissional,
                                  "tipoFuncao",
                                  $$v
                                )
                              },
                              expression: "experienciaProfissional.tipoFuncao",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.experienciaProfissional.tipoFuncao &&
                      _vm.experienciaProfissional.tipoFuncao.isOutro
                        ? _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  rules: _vm.ruleNotEmpty,
                                  label: "Nome da Função",
                                  "prepend-icon": "library_books",
                                  required: "",
                                },
                                model: {
                                  value:
                                    _vm.experienciaProfissional.nomeFuncaoOutro,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.experienciaProfissional,
                                      "nomeFuncaoOutro",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression:
                                    "experienciaProfissional.nomeFuncaoOutro",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _vm.experienciaProfissional.tipoFuncao &&
                      _vm.experienciaProfissional.tipoFuncao
                        .isTemNivelGratificacao
                        ? _c(
                            VCol,
                            { attrs: { cols: "12", md: "12" } },
                            [
                              _c(VAutocomplete, {
                                attrs: {
                                  items: _vm.listaNiveisGratificacoes,
                                  rules: [
                                    (v) =>
                                      !!v ||
                                      "Selecione um nível de gratificação",
                                  ],
                                  "search-input": _vm.nivelGratificacaoSearch,
                                  "item-text": "nome",
                                  label: "Nível da Gratificação",
                                  placeholder: "Digite para pesquisar...",
                                  "persistent-hint": "",
                                  "prepend-icon": "workspace_premium",
                                  required: "",
                                  "return-object": "",
                                },
                                on: {
                                  "update:searchInput": function ($event) {
                                    _vm.nivelGratificacaoSearch = $event
                                  },
                                  "update:search-input": function ($event) {
                                    _vm.nivelGratificacaoSearch = $event
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "no-data",
                                      fn: function () {
                                        return [
                                          _c(
                                            VListItem,
                                            [
                                              _c(
                                                VListItemContent,
                                                [
                                                  _c(VListItemTitle, [
                                                    _vm._v(
                                                      " O nível de gratificação "
                                                    ),
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "secondary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.nivelGratificacaoSearch
                                                          ) + " "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " não foi encontrado. "
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2398634838
                                ),
                                model: {
                                  value:
                                    _vm.experienciaProfissional
                                      .tipoNivelGratificacao,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.experienciaProfissional,
                                      "tipoNivelGratificacao",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "experienciaProfissional.tipoNivelGratificacao",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.experienciaProfissional.tipoNivelGratificacao &&
                      _vm.experienciaProfissional.tipoNivelGratificacao.isOutro
                        ? _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  rules: _vm.ruleNotEmpty,
                                  label: "Nome do Nível de Gratificação",
                                  "prepend-icon": "library_books",
                                  required: "",
                                },
                                model: {
                                  value:
                                    _vm.experienciaProfissional
                                      .nomeNivelGratificacaoOutro,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.experienciaProfissional,
                                      "nomeNivelGratificacaoOutro",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression:
                                    "\n                experienciaProfissional.nomeNivelGratificacaoOutro\n              ",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c("h4", [
                            _vm._v("Situação da Experiência Profissional"),
                          ]),
                          _c(
                            VRadioGroup,
                            {
                              attrs: {
                                rules: [(v) => !!v || "Seleciona o status"],
                                required: "",
                                row: "",
                              },
                              model: {
                                value: _vm.experienciaProfissional.status.id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.experienciaProfissional.status,
                                    "id",
                                    $$v
                                  )
                                },
                                expression: "experienciaProfissional.status.id",
                              },
                            },
                            _vm._l(
                              _vm.statusExperienciaProfissional,
                              function (status) {
                                return _c(VRadio, {
                                  key: status.id,
                                  attrs: {
                                    label: status.text,
                                    value: status.id,
                                    required: "",
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("app-date-select", {
                            attrs: {
                              tipo: "month",
                              label: "Início",
                              tooltip:
                                "Data de início da experiência profissional",
                              "data-inicial":
                                _vm.experienciaProfissional.inicio,
                              min: _vm.minInicioExperienciaProfissional,
                              max: _vm.maxInicioExperienciaProfissional,
                            },
                            on: {
                              return: (value) =>
                                (_vm.experienciaProfissional.inicio = value),
                            },
                          }),
                        ],
                        1
                      ),
                      !_vm.statusAtualExperiencia
                        ? _c(
                            VCol,
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c("app-date-select", {
                                attrs: {
                                  tipo: "month",
                                  label: "Término",
                                  tooltip:
                                    "Data de término da experiência profissional",
                                  "data-inicial":
                                    _vm.experienciaProfissional.termino,
                                  min: _vm.minTerminoExperienciaProfissional,
                                  max: _vm.maxTerminoExperienciaProfissional,
                                },
                                on: {
                                  return: (value) =>
                                    (_vm.experienciaProfissional.termino =
                                      value),
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCardActions,
            [
              _c(
                VRow,
                { staticClass: "justify-end mr-4" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mr-2",
                      attrs: {
                        disabled: !_vm.dialogProps.valid,
                        color: "primary",
                      },
                      on: { click: _vm.doAcao },
                    },
                    [_vm._v(" " + _vm._s(_vm.labelBtnAcao) + " ")]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary", outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogProps.visibilidade = false
                        },
                      },
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }